document.addEventListener('DOMContentLoaded',function(){
  var astmImg = document.querySelector(".astm-img");
  var galileo_cancel = document.querySelector(".galileo-cancel");
  var galileoImg = document.querySelector(".galileoImg");
  var galileo_astm = document.querySelector("#galileo-astm");
  var GalileoBtn = document.getElementById("GalileoBtn");
  GalileoBtn.addEventListener("click",function(){
    galileo_astm.style.display = "block";
  });
    galileo_cancel.addEventListener("click",function(e){
    galileo_astm.style.display = "none";
  })
    galileoImg.addEventListener("click",function(event){
      event.stopPropagation();
  });
})